<template>
  <div>
    <FormField forId="annual-file-upload" :required="true" :labelText="`Uploading supporting documents`">
      <p>You are required to hold valid evidence in order to maintain your eligibility to this health insurance product. We may reach out and request a copy.</p>
      <!-- <FileSelect
          id="annual-file-upload"
          name="annual-file-upload"
          type="file"
          :uploadedFiles="uploadedFiles"
          :uploadStatus="uploadStatus"
          :errorMessage="uploadErrorMessage"
          @upload="uploadFiles"
          @removeError="uploadStatus = ''"
          :removedFilesIndexList="removedFilesIndexList"
          ref="file-upload"
        /> -->
    </FormField>
    <input type="checkbox" id="declarationAcceptance" v-model="formResponse.declarationIsConfirmed" @change="updateDeclarationDates()" />
    <label for="declarationAcceptance">I declare the details that I have provided are true and correct.*</label>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
// import FileSelect from '@general/js/templates/JoinNow/JoinNowSteps/EligibilityTypes/components/FileSelect.vue';
import FormField from '@/components/FormField.vue';
import JoinNowServices from '@general/js/services/JoinNow';
import { LoadingStatus } from '@general/js/enums/StatusEnums';
import { getCurrentDate, getPastOrLaterDateFromInitialDate } from '@general/js/utils';

export default {
  name: 'AnnualEligibilityDeclaration',

  components: {
    // FileSelect,
    FormField,
  },

  props: {
    /**
     * Member number of the currently selected policy
     */
    memberNumber: {
      type: String,
      required: true,
    },
    /**
     * Initial data for the form
     */
    initialData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      uploadedFiles: {
        fileNames: [],
        fileIndices: [],
        size: 0,
        fileInvalid: false,
      },
      uploadStatus: '',
      uploadErrorMessage: '',
      uploadErrorFiles: [],
      removedFilesIndexList: [],
      formResponse: {
        declarationIsConfirmed: false,
        declarationDate: null,
        expiryDate: null,
        sercatFileNames: [],
      },
    };
  },

  mounted() {
    this.formResponse = { ...this.formResponse, ...this.initialData };
  },

  validations: {
    // Declaration tickbox must be ticked and there must be a successful file upload in order to proceed
    uploadStatus: {
      required,
      $value: (value) => {
        return value === LoadingStatus.SUCCESS;
      },
    },
    formResponse: {
      declarationIsConfirmed: {
        required,
        isSelected: (value) => {
          return value;
        },
      },
    },
  },

  watch: {
    v$: {
      handler(newData) {
        this.$emit('updatedAnnualDeclaration', this.formResponse, newData.$invalid);
      },
      deep: true,
    },
  },

  methods: {
    async uploadFiles(files) {
      const formData = new FormData();
      this.uploadStatus = LoadingStatus.PENDING;
      if (files) {
        Array.from(files).forEach((file) => {
          formData.append('file', file, file.name);
        });
      }
      try {
        const res = await JoinNowServices.uploadDocument(formData, this.memberNumber, 'sercat');
        if (res === LoadingStatus.SUCCESS) {
          this.uploadStatus = LoadingStatus.SUCCESS;
          this.uploadSuccess = true;
          Array.from(files).forEach((file) => {
            this.uploadedFiles.fileNames.push(file.name);
            this.uploadedFiles.size += file.size;
            this.formResponse.sercatFileNames.push(file.name);
          });
        }
      } catch (e) {
        this.uploadStatus = LoadingStatus.ERROR;
        this.uploadErrorMessage = e.message;
      }
    },

    updateDeclarationDates() {
      const currentDate = getCurrentDate();
      this.formResponse.declarationDate = currentDate;
      this.formResponse.expiryDate = getPastOrLaterDateFromInitialDate(currentDate, 1);
    },
  },
};
</script>
